import { Col, Divider, Form, Row } from "antd";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import BreadCrumb from "../../components/BreadCrumb/BreadCrumb";
import Button from "../../components/Button/Button";
import { CardContainer } from "../../components/Card/CardContainer";
import PageTitleNested from "../../components/PageTitle/PageTitleNested";
import StepAntd from "../../components/StepAntd/StepAntd";
import {
  createStep1,
  createMainStep2,
  getDataStep1,
  updateFile,
  createSpecialStep2,
  getDataStep2,
  updateStatusSpecialReward,
} from "../../datasource/AchievementDataSource";
import AchievementStep1 from "./CreateAchievementStep/AchievementStep1";
import AchievementStep2 from "./CreateAchievementStep/AchievementStep2";
import AchievementStep3 from "./CreateAchievementStep/AchievementStep3";
import DetailPage from "./TabSection/DetailPage";

export interface imgList {
  key: number;
  imgFile?: any;
  imgUrl?: string;
}

export const imgList_INIT: imgList = {
  key: 1,
  imgFile: undefined,
  imgUrl: undefined,
};

function CreateAchievement() {
  const navigate = useNavigate();
  const userProfile = JSON.parse(localStorage.getItem("profile")!);

  const { pathname } = window.location;
  const pathSplit = pathname.split("/") as Array<string>;
  const id = pathSplit[4];
  const page = pathSplit[5];

  const [step, setStep] = useState<number>(0);
  const [form1] = Form.useForm();
  const [form2] = Form.useForm();
  const [form3] = Form.useForm();

  const [imgFile, setImgFile] = useState<any>();
  const [imgUrl, setImgUrl] = useState<any>();
  const [fileMemo, setFileMemo] = useState<any>();
  const [fileMemoUrl, setFileMemoUrl] = useState<any>();
  const [rule, setRule] = useState<any>();
  const [disableStep, setDisableStep] = useState<boolean>(true);
  const [mainImgBadge, setMainImgBadge] = useState<imgList[]>([imgList_INIT]);
  const [mainImgReward, setMainImgReward] = useState<imgList[]>([imgList_INIT]);

  const [isSpecialReward, setIsSpecialReward] = useState<boolean>(false);
  const [specialImgBadge, setSpecialImgBadge] = useState<imgList[]>([imgList_INIT]);
  const [specialImgReward, setSpecialImgReward] = useState<imgList[]>([imgList_INIT]);

  const getData = async () => {
    await getDataStep1(id).then(async (res) => {
      setImgUrl(res.imageUrl);
      setFileMemoUrl(res.documentUrl);
      setRule(res?.rule);
      form1.setFieldsValue({
        achievementId: res.achievementId,
        achievementCode: res.achievementCode,
        achievementName: res.achievementName,
        company: res.company,
        conditionsToAchieve: res.conditionsToAchieve,
        description: res.description,
        receiveRewardType: res.receiveRewardType,
        refMemo: res.refMemo,
        startDate: dayjs(res.startDate),
        endDate: dayjs(res.endDate),
        startTime: dayjs(res.startDate),
        endTime: dayjs(res.endDate),
        rule: res.rule,
        image: res.imageUrl,
        status: res.status,
        isApproved: res.isApproved,
      });

      if (res.achievementReward[0]?.achievementRewardId) {
        await getDataStep2(res.achievementReward[0]?.achievementRewardId).then((res) => {
          form2.setFieldsValue({
            achievementRewardId: res.achievementRewardId,
            isSpecial: res.isSpecial,
            receiveSpecialRewardType: res.receiveSpecialRewardType || "STEP",
            mainGroups: res.achievementMainReward
              ?.sort((a, b) => a.rewardNum - b.rewardNum)
              .map((e) => ({
                mainRewardId: e.mainRewardId,
                mileStoneName: e.mileStoneName,
                rewardName: e.rewardName,
                rewardNum: e.rewardNum,
                targetAmount: e.targetAmount,
                targetUnit: e.targetUnit,
                badgeMasterId: e.badgeMasterId,
                key: e.rewardNum,
                reward: e.imageUrl,
                badge: e.badgeImageUrl,
              })),
            specialGroups: res.achievementSpecialReward
              ?.sort((a, b) => a.specialRewardNum - b.specialRewardNum)
              .map((e) => ({
                mainRewardId: e.specialRewardId,
                mileStoneName: e.mileStoneSpecialName,
                rewardName: e.specialRewardName,
                rewardNum: e.specialRewardNum,
                targetAmount: e.targetAmount,
                targetUnit: e.targetUnit,
                badgeMasterId: e.badgeMasterId,
                key: e.specialRewardNum,
                reward: e.imageUrl,
                unlockMainRewardNum: Number(e.unlockMainRewardNum),
                badge: e.badgeImageUrl,
              })),
          });
          if (res.achievementMainReward.length > 0) {
            setMainImgBadge(
              res.achievementMainReward
                ?.sort((a, b) => a.rewardNum - b.rewardNum)
                .map((item) => ({
                  key: item.rewardNum,
                  imgFile: undefined,
                  imgUrl: item.badgeImageUrl,
                })),
            );
            setMainImgReward(
              res.achievementMainReward
                ?.sort((a, b) => a.rewardNum - b.rewardNum)
                .map((item) => ({
                  key: item.rewardNum,
                  imgFile: undefined,
                  imgUrl: item.imageUrl,
                })),
            );
          }
          if (res.achievementSpecialReward.length > 0) {
            setSpecialImgBadge(
              res.achievementSpecialReward
                ?.sort((a, b) => a.specialRewardNum - b.specialRewardNum)
                .map((item) => ({
                  key: item.specialRewardNum,
                  imgFile: undefined,
                  imgUrl: item.badgeImageUrl,
                })),
            );
            setSpecialImgReward(
              res.achievementSpecialReward
                ?.sort((a, b) => a.specialRewardNum - b.specialRewardNum)
                .map((item) => ({
                  key: item.specialRewardNum,
                  imgFile: undefined,
                  imgUrl: item.imageUrl,
                })),
            );
          }
        });
      }
    });
  };

  useEffect(() => {
    if (id === "0") {
      form1.setFieldsValue({
        achievementCode: "",
        refMemo: "",
        description: "",
        startDate: "",
        endDate: "",
        conditionsToAchieve: "THB",
        receiveRewardType: "STEP",
        image: "",
        status: "PENDING",
        isApproved: false,
      });
    } else {
      setDisableStep(true);
      setStep(0);
      getData();
    }
  }, []);

  const PageTitle = () => {
    return (
      <PageTitleNested
        title={page === "detail" ? "แก้ไขความสำเร็จ" : "สร้างความสำเร็จ"}
        showBack
        onBack={() =>
          page === "detail" ? navigate(`/crm/achievement/${id}`) : navigate("/crm/achievement")
        }
        extra={
          <StepAntd
            current={step}
            items={[
              {
                title: "ข้อมูลเบื้องต้น",
              },
              {
                title: "ตั้งค่าของรางวัล",
              },
              {
                title: "ร้านค้าและสินค้า",
              },
              {
                title: "ยืนยัน",
              },
            ]}
          />
        }
        customBreadCrumb={
          <BreadCrumb
            data={[
              { text: "รายการความสำเร็จ", path: "/crm/achievement" },
              {
                text: page === "detail" ? "แก้ไขความสำเร็จ" : "สร้างความสำเร็จ",
                path: window.location.pathname,
              },
            ]}
          />
        }
      />
    );
  };

  const stepsComponents = [
    <AchievementStep1
      key={0}
      form1={form1}
      setImgFile={setImgFile}
      setImgUrl={setImgUrl}
      setFileMemo={setFileMemo}
      setFileMemoUrl={setFileMemoUrl}
      imgUrl={imgUrl}
      fileMemoUrl={fileMemoUrl}
      rule={rule}
      status={form1.getFieldValue("status")}
      isApproved={form1.getFieldValue("isApproved")}
    />,
    <AchievementStep2
      key={1}
      form2={form2}
      achievementRewardId={form2.getFieldValue("achievementRewardId")}
      setDisableStep={setDisableStep}
      targetType={form1.getFieldValue("conditionsToAchieve")}
      status={form1.getFieldValue("status")}
      isApproved={form1.getFieldValue("isApproved")}
      mainImgBadge={mainImgBadge}
      setMainImgBadge={setMainImgBadge}
      mainImgReward={mainImgReward}
      setMainImgReward={setMainImgReward}
      specialImgBadge={specialImgBadge}
      setSpecialImgBadge={setSpecialImgBadge}
      specialImgReward={specialImgReward}
      setSpecialImgReward={setSpecialImgReward}
      isSpecialReward={isSpecialReward}
      setIsSpecialReward={setIsSpecialReward}
    />,
    <AchievementStep3
      key={2}
      form3={form3}
      achievementId={form1.getFieldValue("achievementId")}
      achievementRewardId={form2.getFieldValue("achievementRewardId")}
      setDisableStep={setDisableStep}
      status={form1.getFieldValue("status")}
      isApproved={form1.getFieldValue("isApproved")}
    />,
    <DetailPage key={3} achievementId={form1.getFieldValue("achievementId")} isStep4={true} />,
  ];

  const createStep2 = async () => {
    const dataFrom2 = form2.getFieldsValue(true);
    const mapDataMain = dataFrom2.mainGroups;
    const mapDataSpecial = dataFrom2.specialGroups;

    if (mapDataMain.length > 0) {
      for (let i = 0; mapDataMain.length > i; i++) {
        const m = mapDataMain[i];
        const formData = new FormData();
        const findImgBadge = mainImgBadge?.find((x) => x.key == m.key);
        const findImgReward = mainImgReward?.find((x) => x.key == m.key);
        const mapBadgeUrl = !findImgBadge?.imgFile ? "NO_ACTION" : "UPLOAD";
        const mapRewardUrl = !findImgReward?.imgFile ? "NO_ACTION" : "UPLOAD";

        formData.append("achievementRewardId", form2.getFieldsValue(true).achievementRewardId);
        m.mainRewardId && formData.append("mainRewardId", m.mainRewardId);
        formData.append("mileStoneName", m.mileStoneName);
        formData.append("rewardName", m.rewardName);
        formData.append("rewardNum", m.rewardNum);
        formData.append("targetAmount", m.targetAmount);
        formData.append("targetUnit", form1.getFieldValue("conditionsToAchieve"));
        formData.append("badgeMasterId", m.badgeMasterId);
        formData.append("badgeAction", mapBadgeUrl);
        formData.append("imageAction", mapRewardUrl);
        !mapBadgeUrl.includes("NO") && formData.append("badge", findImgBadge?.imgFile);
        !mapRewardUrl.includes("NO") && formData.append("image", findImgReward?.imgFile);
        await createMainStep2(formData).then((res) => res);
      }
    }
    if (mapDataSpecial.length > 0) {
      for (let i = 0; mapDataSpecial.length > i; i++) {
        const m = mapDataSpecial[i];
        const formData = new FormData();
        const findImgBadge = specialImgBadge?.find((x) => x.key == m.key);
        const findImgReward = specialImgReward?.find((x) => x.key == m.key);
        const mapBadgeUrl = !findImgBadge?.imgFile ? "NO_ACTION" : "UPLOAD";
        const mapRewardUrl = !findImgReward?.imgFile ? "NO_ACTION" : "UPLOAD";

        formData.append("achievementRewardId", form2.getFieldsValue(true).achievementRewardId);
        m.mainRewardId && formData.append("specialRewardId", m.mainRewardId);
        formData.append("mileStoneSpecialName", m.mileStoneName);
        formData.append("specialRewardName", m.rewardName);
        formData.append("specialRewardNum", m.rewardNum);
        formData.append("targetAmount", m.targetAmount);
        formData.append("targetUnit", form1.getFieldValue("conditionsToAchieve"));
        formData.append("unlockMainRewardNum", m.unlockMainRewardNum);
        formData.append(
          "receiveSpecialRewardType",
          form2.getFieldValue("receiveSpecialRewardType"),
        );
        formData.append("badgeMasterId", m.badgeMasterId);
        formData.append("badgeAction", mapBadgeUrl);
        formData.append("imageAction", mapRewardUrl);
        !mapBadgeUrl.includes("NO") && formData.append("badge", findImgBadge?.imgFile);
        !mapRewardUrl.includes("NO") && formData.append("image", findImgReward?.imgFile);
        await createSpecialStep2(formData).then((res) => res);
      }
    }
  };

  const updateIsSpecial = async () => {
    await updateStatusSpecialReward({
      achievementRewardId: form2.getFieldsValue(true).achievementRewardId,
      isSpecial: isSpecialReward,
      updatedBy: `${userProfile.firstname} ${userProfile.lastname}`,
    }).then((res) => {
      if (res.success) {
        form2.setFieldsValue({
          isSpecial: isSpecialReward,
          receiveSpecialRewardType: "STEP",
        });
      }
    });
  };

  const onNext = async () => {
    if (step === 0) {
      try {
        await form1.validateFields().then(async (value) => {
          const dataFrom1 = form1.getFieldsValue(true);
          const create = { ...dataFrom1 };
          create.company = userProfile.company;
          create.startDate = dayjs(
            `${dataFrom1.startDate.format("YYYY-MM-DD")} ${dataFrom1.startTime.format("HH:mm")}:00.000`,
          ).toISOString();
          create.endDate = dayjs(
            `${dataFrom1.endDate.format("YYYY-MM-DD")} ${dataFrom1.endTime.format("HH:mm")}:00.000`,
          ).toISOString();
          create.updatedBy = `${userProfile.firstname} ${userProfile.lastname}`;

          const mapImgUrl = !imgFile ? "NO_ACTION" : "UPLOAD";
          const mapDocUrl = !fileMemo ? "NO_ACTION" : "UPLOAD";

          await createStep1(create).then(async (res) => {
            if (res.success) {
              const dataReturn = res.responseData;
              form1.setFieldsValue({
                achievementId: dataReturn.achievementId,
                achievementCode: dataReturn.achievementCode,
              });
              form2.setFieldValue(
                "achievementRewardId",
                dataReturn?.achievementReward[0]?.achievementRewardId,
              );
              const formData = new FormData();
              formData.append("achievementId", dataReturn.achievementId);
              formData.append("imageAction", mapImgUrl);
              formData.append("documentAction", mapDocUrl);
              !mapImgUrl.includes("NO") && formData.append("image", imgFile);
              !mapDocUrl.includes("NO") && formData.append("document", fileMemo.originFileObj);
              formData.append("updateBy", `${userProfile.firstname} ${userProfile.lastname}`);
              await updateFile(formData).then((res) => {
                if (res.success) {
                  setStep(step + 1);
                  navigate(`/crm/achievement/create/${dataReturn.achievementId}/${page}`);
                }
              });
            }
          });
        });
      } catch (e) {
        console.log(e);
      }
    } else if (step == 1) {
      try {
        await form2.validateFields().then(async (value) => {
          updateIsSpecial();
          createStep2();
        });
        setDisableStep(false);
        setStep(step + 1);
      } catch (e: any) {
        console.log(e);
      }
    } else if (step == 2) {
      setDisableStep(false);
      setStep(step + 1);
    } else {
      const dataFrom1 = form1.getFieldsValue(true);
      const create = { ...dataFrom1 };
      create.company = userProfile.company;
      create.startDate = dayjs(
        `${dataFrom1.startDate.format("YYYY-MM-DD")} ${dataFrom1.startTime.format("HH:mm")}:00.000`,
      ).toISOString();
      create.endDate = dayjs(
        `${dataFrom1.endDate.format("YYYY-MM-DD")} ${dataFrom1.endTime.format("HH:mm")}:00.000`,
      ).toISOString();
      create.updatedBy = `${userProfile.firstname} ${userProfile.lastname}`;
      await createStep1(create).then(async (res) => {
        if (res.success) {
          navigate("/crm/achievement");
        }
      });
    }
  };

  const onPrevious = async () => {
    if (step === 1) {
      await updateIsSpecial();
      await createStep2();
      await getData();
    }
    setDisableStep(true);
  };

  return (
    <>
      <CardContainer>
        <PageTitle />
        <Divider />
        {stepsComponents[step]}
        <Divider />
        <Row justify='space-between' gutter={12}>
          <Col xl={3} sm={6}>
            {step > 0 && (
              <Button
                typeButton={step === 1 && disableStep ? "disabled" : "primary-light"}
                disabled={step === 1 && disableStep}
                title='ย้อนกลับ'
                onClick={() => {
                  setStep(step - 1);
                  onPrevious();
                }}
              />
            )}
          </Col>
          <Col xl={15} sm={6}></Col>
          <Col xl={3} sm={6}>
            <Button
              typeButton={step !== 0 && disableStep ? "disabled" : "primary"}
              title={step === 3 ? "บันทึก" : "บันทึกและถัดไป"}
              onClick={() => onNext()}
              disabled={step !== 0 && disableStep}
            />
          </Col>
        </Row>
      </CardContainer>
    </>
  );
}

export default CreateAchievement;
